import { useCallback, useMemo } from 'react'

import { toast } from '@buffer-mono/popcorn'
import { FileUploadConfig, defaultRestrictions } from '@buffer-mono/uploader'
import type { useUploader, UploaderEvents } from '@buffer-mono/uploader'

import { IDEAS_UPLOADER_ID } from '~publish/components/LegacyIdeaComposer/constants'
import usePublishUploader from '~publish/legacy/uploads/hooks/usePublishUploader'

const fileRestrictions = {
  ...defaultRestrictions,
  uploadConfig: FileUploadConfig.IDEAS,
}

export default function useIdeasUploader(): ReturnType<typeof useUploader> {
  const showError = useCallback((message: string): void => {
    toast.warning(message, { duration: Infinity })
  }, [])

  const eventHandlers: Partial<UploaderEvents> = useMemo(
    () => ({
      'file-validation-failed': (_, error): void => showError(error.message),
      'upload-failed': (_, error): void => showError(error.message),
      'file-fetch-failed': (): void =>
        showError('Failed to retrieve the selected file.'),
    }),
    [showError],
  )

  return usePublishUploader({
    id: IDEAS_UPLOADER_ID,
    fileRestrictions,
    eventHandlers,
  })
}
